<template>
  <div class="login-container">
    <div class="header">
      <div class="logo">
        <el-image :src="logo" style="width: 50px; height: 50px" />
        <span class="text">
          {{ $t('cai-gou-xun-jia-xi-tong') }} 
        </span>
        <el-tag size="small" type="success">
          V1.0
        </el-tag>
      </div>
      <div class="lang">
        <lang-select class="select" size="20px" />
      </div>
    </div>
    <!-- 登录表单 -->
    <div class="login-content">
      <div class="login-image">
        <el-image :src="loginImage" style="width: 210px; height: 210px" />
      </div>
      <div class="login-box">
        <el-form
          ref="loginFormRef"
          :model="loginData"
          :rules="loginRules"
          class="login-form"
        >
          <h2 class="text" style="font-family:楷体;">
            {{ $t("login.login") }}
          </h2>
          <!-- 用户名 -->
          <el-form-item prop="username">
            <div class="input-wrapper">
              <svg-icon icon-class="user" class="icon" size="1.2em" />
              <el-input
                ref="username"
                v-model="loginData.username"
                :placeholder="$t('login.username')"
                name="username"
                size="large"
                class="user"
              />
            </div>
          </el-form-item>
          <!-- 密码 -->
          <el-tooltip
            :visible="isCapslock"
            :content="$t('login.capsLock')"
            placement="right"
          >
            <el-form-item prop="password">
              <div class="input-wrapper">
                <svg-icon icon-class="password" class="icon" size="1.2em" />
                <el-input
                  v-model="loginData.password"
                  :placeholder="$t('login.password')"
                  type="password"
                  name="password"
                  @keyup="checkCapslock"
                  @keyup.enter="handleLoginSubmit"
                  size="large"
                  class="password"
                  show-password
                />
              </div>
            </el-form-item>
          </el-tooltip>
          <!-- 验证码 -->
          <!-- <el-form-item prop="captchaCode">
            <div class="input-wrapper">
              <svg-icon icon-class="captcha" class="icon" size="1.2em" />
              <el-input
                v-model="loginData.captchaCode"
                auto-complete="off"
                size="large"
                class="captcha"
                :placeholder="$t('login.captchaCode')"
                @keyup.enter="handleLoginSubmit"
              />
              <el-image
                @click="getCaptcha"
                :src="captchaBase64"
                class="captcha-image"
              />
            </div>
          </el-form-item> -->
          <div class="remember">
            <el-checkbox v-model="checkValue" @change="rememberChange">
              {{ $t("login.rememberMe") }}
            </el-checkbox>
            <el-link type="primary" @click="openDialog">
              注册账号
            </el-link>
          </div><br />
          <!-- 登录按钮 -->
          <el-button
            :loading="loading"
            type="primary"
            size="large"
            style="width: 100%;"
            @click.prevent="handleLoginSubmit"
          >
            {{ $t('que-ding') }} 
          </el-button>
          <el-divider>
            <svg-icon icon-class="message" color="red" size="15px" />
          </el-divider>
          <div class="suggestion">
            <p class="text">{{ $t('jian-yi-liu-lan-qi-edgechrome') }}</p>
            <p class="text">{{ $t('jian-yi-fen-bian-ni') }}</p>
          </div>
        </el-form>
      </div>
    </div>
    <!-- ICP备案 -->
    <div class="foot">
      <p style="color: #666666;">
        Copyright © 2024 Toyo Communication Technology ShenZhen Co.,LTD
      </p>
    </div>
    <el-dialog
      v-model="centerDialogVisible"
      title="用户注册"
      destroy-on-close
      center
      align-center
      class="loginDialog"
      width="580"
      @open="dialogOpen"
    >
      <el-form
        ref="registerForm"
        style="width: 100%"
        :model="registerModel"
        :rules="registerRules"
        label-width="auto"
        class="demo-ruleForm"
        :size="formSize"
        status-icon
      >
        <el-form-item label="用户名" prop="username">
          <el-input 
            placeholder="请输入用户名" 
            v-model="registerModel.username" 
            clearable
          />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input 
            type="password" 
            name="password" 
            placeholder="请输入密码" 
            v-model="registerModel.password"
            show-password
            clearable
          />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input 
            type="password" 
            name="password" 
            placeholder="请再次输入密码" 
            v-model="registerModel.confirmPassword"
            show-password
            clearable
          />
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-select
            v-model="registerModel.gender"
            placeholder="请选择性别"
            clearable
          >
            <el-option
              v-for="item in genderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="手机号码" prop="phone">
          <el-input 
            placeholder="请输入手机号码" 
            v-model="registerModel.phone" 
            clearable
          />
        </el-form-item>
        <el-form-item label="邮箱地址" prop="email">
          <el-input 
            placeholder="请输入邮箱地址" 
            v-model="registerModel.email" 
            clearable
          />
        </el-form-item>
        <el-form-item label="公司名称" prop="companyName">
          <el-input 
            placeholder="请输入公司名称" 
            v-model="registerModel.companyName" 
            clearable
          />
        </el-form-item>
        <el-form-item label="公司地址" prop="address">
          <el-input 
            placeholder="请输入公司地址" 
            v-model="registerModel.address" 
            clearable
          />
        </el-form-item>
        <el-form-item label="备注" prop="notes">
          <el-input 
            type="textarea"
            v-model="registerModel.notes" 
          />
        </el-form-item>
        <el-form-item label="验证码" prop="captchaCode">
          <el-input
            v-model="registerModel.captchaCode"
            auto-complete="off"
            size="large"
            class="captcha"
            :placeholder="$t('login.captchaCode')"
            @focus="regCaptcha"
            clearable
          >
            <template #append>
              <el-image
                @click="getRegisterCaptcha"
                :src="registerCaptchaBase64"
                class="captcha-image"
              />
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取消</el-button>
          <el-button :loading="registerLoading" type="primary" @click="registerSubmit(registerForm)">
            注册
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import type { LocationQuery } from "#vue-router";
// 类型定义
import type { FormInstance, ComponentSize } from "element-plus";
// 导入 login.scss 文件
import "/assets/scss/login.scss";

const user = useUserStore();
// const { userInfo } = storeToRefs(user);
// 使用导入的依赖和库
const route = useRoute();
// 窗口高度
const { height, width } = useWindowSize();
const screenHeight = ref<number>(0);
// 国际化 Internationalization
const { t } = useI18n();
// 是否显示 ICP 备案信息
const icpVisible = ref(true);
// 按钮 loading 状态
const loading = ref(false);
// 是否大写锁定
const isCapslock = ref(false);
// 验证码图片Base64字符串
const captchaBase64 = ref();
// 登录表单ref
const loginFormRef = ref<FormInstance>();
// 公司LOGO
const logo = ref(new URL(`@/assets/logo.png`, import.meta.url).href);
// 登录左边图片
const loginImage = ref(
  new URL(`@/assets/images/login-image.svg`, import.meta.url).href
);
// 注册对话框开关
const formSize = ref<ComponentSize>('default');
const registerForm = ref<FormInstance>();
const registerModel = ref({
  username: "",
  password: "",
  confirmPassword: "",
  gender: "",
  phone: "",
  email: "",
  companyName: "",
  address: "",
  notes: "",
  captchaKey: "",
  captchaCode: ""
});
const validateConfirmPassword = (rule: any, value: any, callback: any) => {
  if (value !== registerModel.value.password) {
    callback(new Error("两次输入密码不匹配"));
  } else {
    callback();
  }
};
const validateMobile = async (rule: any, value: string, callback: (error?: Error) => void) => {
  if (!/^1(3|4|5|6|7|8|9)[0-9]\d{8}$/.test(value)) {
    callback(new Error('请输入正确的手机号'));
  } else {
    let mobiles = await userRegisterFetch({
      method: 'get',
      query: {
        field: 'FPhone',
        value
      }
    })
    if (mobiles.data.length > 0) {
      callback(new Error('该手机号码已注册'));
    } else {
      callback();
    }
  }
};
const validateEmail = async (rule: any, value: string, callback: (error?: Error) => void) => {
  if(!value.trim()) {
    callback();
  } else if (!/^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(value)) {
    callback(new Error('请输入正确的邮箱'));
  } else {
    let emails = await userRegisterFetch({
      method: 'get',
      query: {
        field: 'FEmail',
        value
      }
    })
    if (emails.data.length > 0) {
      callback(new Error('该邮箱已注册'));
    } else {
      callback();
    }
  }
};
const validateUsername = async (rule: any, value: string, callback: (error?: Error) => void) => {
  let names = await userRegisterFetch({
    method: 'get',
    query: {
      field: 'FName',
      value
    }
  })
  console.log('names', names)
  if (names.data.length > 0) {
    callback(new Error('该用户名已注册'));
  } else {
    callback();
  }
};
const registerRules = computed(() => {
  return {
    username: [
      { required: true, message: '请输入用户名称', trigger: 'blur' },
      { min: 2, max: 4, message: '用户名长度2到4个字符', trigger: 'blur' },
      { validator: validateUsername, trigger: 'blur' },
    ],
    password: [
      { required: true, message: '请输入密码', trigger: 'blur' },
      { min: 6, max: 10, message: '密码长度6到10个字符', trigger: 'blur' },
    ],
    confirmPassword: [
      { required: true, message: '请再次输入密码', trigger: 'blur' },
      { min: 6, max: 10, message: '密码长度6到10个字符', trigger: 'blur' },
      { validator: validateConfirmPassword, trigger: 'blur' },
    ],
    gender: [
      { required: true, message: '请选择性别', trigger: 'blur' },
    ],
    phone: [
      { required: true, message: '请输入手机号码', trigger: 'blur' },
      { validator: validateMobile, trigger: 'blur' },
    ],
    email: [
      // { required: true, message: '请输入邮箱地址', trigger: 'blur' },
      { validator: validateEmail, trigger: 'blur' },
      { min: 1, max: 150, message: '邮箱地址长度1到150个字符', trigger: 'blur' },
    ],
    companyName: [
      { required: true, message: '请输入公司名称', trigger: 'blur' },
      { min: 1, max: 100, message: '公司名称长度1到100个字符', trigger: 'blur' },
    ],
    address: [
      { required: true, message: '请输入公司地址', trigger: 'blur' },
      { min: 1, max: 255, message: '公司名称长度1到255个字符', trigger: 'blur' },
    ],
    notes: [
      { min: 0, max: 255, message: '备注长度1到255个字符', trigger: 'blur' },
    ],
    captchaCode: [
      { required: true, message: '请输入验证码', trigger: 'blur' },
    ],
  }
})
const centerDialogVisible = ref(false);
const openDialog = () => {
  centerDialogVisible.value = true;
};
const genderOptions = ref([
  {
    value: 0,
    label: "男"
  },
  {
    value: 1,
    label: "女"
  }
]);
const registerLoading = ref(false);
const registerSubmit = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  registerLoading.value = true;
  formEl.validate(async (valid) => {
    if (valid) {
      try {
        let result = await userSaveFetch({
          method: 'post',
          body: registerModel.value
        });
        if(result.code == 0) {
          ElMessage({
            message: '注册成功，等待审核',
            type: 'success',
          })
          registerLoading.value = false;
          centerDialogVisible.value = false;
          registerForm.value?.resetFields();
        } else {
          ElMessage({
            message: result.msg,
            type: 'error',
          });
          registerLoading.value = false;
          getRegisterCaptcha();
        }
      } catch(err: any) {
        ElMessage({
          message: err,
          type: 'error',
        });
        registerLoading.value = false;
        getRegisterCaptcha();
      }
    } else {
      registerLoading.value = false;
    }
  })
};
const dialogOpen = () => {
  getRegisterCaptcha();
};
const regCaptcha = () => {
  getRegisterCaptcha();
}
// 登录表单Form
const loginData = ref({
  username: "",
  password: "",
  // captchaKey: "",
  // captchaCode: "",
});
const checkValue = ref(false);
const rememberChange = (e: any) => {
  if(e) {
    localStorage.setItem('username', loginData.value.username);
    localStorage.setItem('password', loginData.value.password);
  } else {
    localStorage.removeItem('username');
    localStorage.removeItem('password');
  }
}
// 登录表单校验
const loginRules = computed(() => {
  return {
    username: [
      {
        required: true,
        trigger: "blur",
        message: t("login.message.username.required"),
      },
    ],
    password: [
      {
        required: true,
        trigger: "blur",
        message: t("login.message.password.required"),
      },
      {
        min: 6,
        message: t("login.message.password.min"),
        trigger: "blur",
      },
    ],
    // captchaCode: [
    //   {
    //     required: true,
    //     trigger: "blur",
    //     message: t("login.message.captchaCode.required"),
    //   },
    // ],
  };
});
/** 获取登录验证码 */
// async function getCaptcha() {
//   let data = await captchaFetch({ method: 'get' });
//   captchaBase64.value = data.captchaBase64;
//   loginData.value.captchaKey = data.captchaKey;
// }
/** 获取注册验证码 */
const registerCaptchaBase64 = ref<string>('');
async function getRegisterCaptcha() {
  let data = await captchaFetch({ method: 'get' });
  registerCaptchaBase64.value = data.captchaBase64;
  registerModel.value.captchaKey = data.captchaKey;
}
/** 登录表单提交 */
function handleLoginSubmit() {
  loading.value = true;
  loginFormRef.value?.validate(async (valid: boolean) => {
    if (valid) {
      try {
        //请求登录接口
        const data = await loginFetch({
          method:'POST',
          body:{
            username:loginData.value.username,
            password:loginData.value.password,
            // captchaKey: loginData.value.captchaKey,
            // captchaCode: loginData.value.captchaCode
          },
          // server:false,
          // key:'loginFetch'
        })
        if (data.code === 0) {
          ElMessage({
            message: '登录成功',
            type: 'success',
          })
          // 存到useCookie里
          const accessTokenCookie = useCookie('accessToken', { maxAge: 60 * 60 * 8 * 1 });
          accessTokenCookie.value = data.data.Token;
          //存用户信息
          // const userInfoCookie = useCookie('userInfo', { maxAge: 60 * 60 * 24 * 1 })
          // userInfoCookie.value = data.data.User;
          // userInfo.value = data.data.User;
          const query: LocationQuery = route.query;
          let redirect = (query.redirect as string) ?? "/home";
          redirect = decodeURI(redirect);
          await navigateTo(redirect, { redirectCode: 301 });
          loading.value = false;
        } else {
          ElMessage({
            message: data.msg,
            type: 'error',
          });
          loading.value = false;
          // await getCaptcha();
        }
      } catch(err: any) {
        ElMessage({
          message: err,
          type: 'error',
        });
        loading.value = false;
        // await getCaptcha();
      }
    }
    loading.value = false;
  });
}
/** 根据屏幕宽度切换设备模式 */
watchEffect(() => {
  if (height.value < 600) {
    icpVisible.value = false;
  } else {
    icpVisible.value = true;
  }
});
/** 检查输入大小写 */
function checkCapslock(event: KeyboardEvent) {
  // 防止浏览器密码自动填充时报错
  if (event instanceof KeyboardEvent) {
    isCapslock.value = event.getModifierState("CapsLock");
  }
}
// 初始化后获取验证码
onMounted(() => {
  // getCaptcha(); // 如果启用登录验证码，打开注释
  screenHeight.value = window.innerHeight;
  const savedUsername = localStorage.getItem('username')
  const savedPassword = localStorage.getItem('password')
  if (savedUsername && savedPassword) {
    loginData.value.username = savedUsername;
    loginData.value.password = savedPassword;
    checkValue.value = true;
  }
});
</script>

<style lang="scss" scoped>
.login-container {
  .loginDialog {
    .demo-ruleForm {
      .el-form-item {
        :deep(.el-form-item__content) {
          .el-input-group__append {
            padding: 0;
            background-color: var(--el-fill-color-blank);
            .captcha-image {
              cursor: pointer;
              height: 100%;
            }
          }
        }
      }
    }
    
  }
  :deep(.el-dialog) {
    @media (width <= 768px) {
      --el-dialog-width: 96%!important;
    }
  }
  .remember {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-top: 0.25rem; /* 4px */
    padding-bottom: 0.25rem; /* 4px */
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    padding: 0.5rem;
    .logo {
      display: flex;
      align-items: center;
      justify-content: center;
      .text {
        font-size: 1.5rem; /* 24px */
        line-height: 2rem; /* 32px */
        font-weight: 700;
        --un-gradient-shape: to right;
        --un-gradient: var(--un-gradient-shape), var(--un-gradient-stops);
        background-image: linear-gradient(var(--un-gradient));
        --un-gradient-from-position: 0%;
        --un-gradient-from: rgb(59 130 246 / var(--un-from-opacity, 1))
          var(--un-gradient-from-position);
        --un-gradient-to-position: 100%;
        --un-gradient-to: rgb(59 130 246 / 0) var(--un-gradient-to-position);
        --un-gradient-stops: var(--un-gradient-from), var(--un-gradient-to);
        --un-gradient-to-position: 100%;
        --un-gradient-to: rgb(20 184 166 / var(--un-to-opacity, 1))
          var(--un-gradient-to-position);
        color: transparent;
        -webkit-background-clip: text;
        background-clip: text;
        margin-left: 0.25rem; /* 4px */
        margin-right: 0.25rem; /* 4px */
      }
      .lang {
        display: flex;
        align-items: center;
        justify-content: center;
        .select {
          margin-left: 0.5rem;
          cursor: pointer;
        }
      }
    }
  }
  .login-content {
    .login-box {
      display: flex;
      flex: 2;
      flex-direction: column;
      justify-content: center;
      min-width: 400px;
      padding: 30px;    
      .login-form {
        .text {
          font-size: 1.25rem; /* 20px */
          line-height: 1.75rem; /* 28px */
          font-weight: 500;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }
        .el-form-item {
          background: var(--el-input-bg-color);
          border: 1px solid var(--el-border-color);
          border-radius: 5px;
        }
        .input-wrapper {
          display: flex;
          align-items: center;
          width: 100%;
          .el-input {
            :deep(.el-input__wrapper) {
              padding: 0;
              background-color: transparent;
              box-shadow: none;
              &.is-focus,
              &:hover {
                box-shadow: none !important;
              }
              input:-webkit-autofill {
                /* 通过延时渲染背景色变相去除背景颜色 */
                transition: background-color 1000s ease-in-out 0s;
              }
            }
          }
          .icon {
            margin-left: 0.5rem; /* 8px */
            margin-right: 0.5rem; /* 8px */
          }
          .user {
            height: 48px;
          }
          .password {
            height: 48px;
            padding-right: 0.5rem;
          }
          .captcha {
            flex: 1 1 0%;
          }
        }
        .suggestion {
          display: flex;
          flex-direction: column;
          justify-content: center;
          .text {
            font-size: 12px;
            font-weight: 200;
            color: #b3bbd1;
          }
        }
      }
      @media (width <= 768px) {
        width: 100%;
      }
    }
  }
  .foot {
    position: absolute;
    bottom: 5px;
    width: 100%;
    text-align: center;
    font-size: 16px;
  }
}
</style>
